import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MdDialogRef } from '@angular/material';
import { Customer } from '../../../agatextscreens/accounting/customer';
import { Observable } from 'rxjs/Observable';
import { CustomerService } from '../../../agatextscreens/accounting/customer/customer.service';

@Component({
  selector: 'app-select-customer-dialog',
  templateUrl: './select-customer-dialog.component.html',
  styleUrls: ['./select-customer-dialog.component.scss'],
  providers: [CustomerService]
})
export class SelectCustomerDialog implements OnInit, OnDestroy {

  branch_id: string = 'All';

  subscription: Subscription = new Subscription();
  selectedCustomer: Customer;
  cust: any;

  allCustomers: Customer[] = [];
  matchingCustomers: Customer[] = [];

  constructor(private _dialogRef: MdDialogRef<SelectCustomerDialog>,
    private _customerService: CustomerService) { }

  ngOnInit() {

    if (this.branch_id == 'All') {

      this.subscription.add(
        this._customerService
        .getCustomers()
        .subscribe((customers: Customer[]) => {
          this.allCustomers = customers;
          this.matchingCustomers = customers.slice(0, 100);
  
          //this._loadingService.resolve('loading');
        })
      );
    } else {
      console.log('getting customers for branch: ' + this.branch_id);

      this.subscription.add(
        this._customerService
        .getCustomersByBranch(this.branch_id)
        .subscribe((customers: Customer[]) => {
          this.allCustomers = customers;
          this.matchingCustomers = customers.slice(0, 100);
  
          //this._loadingService.resolve('loading');
        })
      );

    }
  }

  ngOnDestroy() {
    console.log('unsubscribing');

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


  setSelected(customer: Customer) {
    this.selectedCustomer = customer;
  }


  // Filter based on user input
  filter(input: string) {
    console.log('input: ' + input);

      this.matchingCustomers = this.allCustomers.filter(
        (cust: Customer) => {
          let full_name = cust.prefix + ' - ' + cust.name;
          return full_name.toLowerCase().includes(input.toLowerCase());
        }
      ).slice(0,100); // limit the matches to 100
  }


  close(result: Customer) {
    this._dialogRef.close(result);
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/shared/dialogs/select-customer-dialog/select-customer-dialog.component.ts